// extracted by mini-css-extract-plugin
export default {"customCell":"tablestyles_customCell__YoJhT","customHeader":"tablestyles_customHeader__iX+Qn"};